/**
 * KP Coupon — tap/click (or keyboard) on a coupon to:
 *   1. copy the discount code to the clipboard,
 *   2. actually apply it to the session via Shopify's /discount/<code> link
 *      (sets the discount cookie → auto-applied at checkout),
 *   3. swap the helper line to a "copied — auto applied" confirmation.
 *
 * Delegated listeners so it also works for cloned/scroll-snap slides.
 */
(function () {
  'use strict';

  var SELECTOR = '[data-coupon-code]';
  var HINT_SELECTOR = '.kp-coupon__hint';
  var COPIED_CLASS = 'is-copied';
  var COPIED_TEXT = 'Code copied — auto applied at checkout';
  var RESET_MS = 3200;

  function copyText(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text);
    }
    return new Promise(function (resolve, reject) {
      try {
        var ta = document.createElement('textarea');
        ta.value = text;
        ta.setAttribute('readonly', '');
        ta.style.position = 'absolute';
        ta.style.left = '-9999px';
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
        resolve();
      } catch (err) {
        reject(err);
      }
    });
  }

  // Apply the code to the current session so it auto-applies at checkout.
  // Fetching /discount/<code> follows Shopify's redirect and sets the cookie
  // without navigating the customer away from the page.
  function applyDiscount(code) {
    try {
      fetch('/discount/' + encodeURIComponent(code), {
        method: 'GET',
        credentials: 'same-origin',
        redirect: 'follow',
        headers: { Accept: 'text/html' }
      }).catch(function () {});
    } catch (e) {
      /* no-op */
    }
  }

  function showCopied(el) {
    var hint = el.querySelector(HINT_SELECTOR);
    if (hint) {
      if (hint.getAttribute('data-original') === null) {
        hint.setAttribute('data-original', hint.textContent);
      }
      hint.textContent = el.getAttribute('data-coupon-copied-text') || COPIED_TEXT;
    }
    // Restart the CSS effect even if tapped again within the window.
    el.classList.remove(COPIED_CLASS);
    void el.offsetWidth; // force reflow so the animation replays
    el.classList.add(COPIED_CLASS);

    window.clearTimeout(el._kpCopyTimer);
    el._kpCopyTimer = window.setTimeout(function () {
      el.classList.remove(COPIED_CLASS);
      if (hint && hint.getAttribute('data-original') !== null) {
        hint.textContent = hint.getAttribute('data-original');
      }
    }, RESET_MS);
  }

  function handle(el) {
    var code = el.getAttribute('data-coupon-code');
    if (!code) return;
    copyText(code).catch(function () {});
    applyDiscount(code);
    showCopied(el);
  }

  document.addEventListener('click', function (e) {
    var el = e.target.closest(SELECTOR);
    if (el) handle(el);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var el = e.target.closest(SELECTOR);
    if (!el) return;
    e.preventDefault();
    handle(el);
  });
})();
